import { render, staticRenderFns } from "./smallPieces.vue?vue&type=template&id=60b46c45&scoped=true&"
import script from "./smallPieces.vue?vue&type=script&lang=js&"
export * from "./smallPieces.vue?vue&type=script&lang=js&"
import style0 from "./smallPieces.vue?vue&type=style&index=0&id=60b46c45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b46c45",
  null
  
)

component.options.__file = "smallPieces.vue"
export default component.exports